export function DraggableStyles(draggableProps, hide, onChangeStatus) {
  const { style = "" } = draggableProps;

  style.left = "0px";

  if (style.transform) {
    const yCoord = style.transform.substring(style.transform.lastIndexOf(", ") + 1, style.transform.lastIndexOf("px)"));

    const yCoordMod = Math.abs(yCoord) >= 24 ? yCoord : 0;

    const xCoord = style.transform.substring(style.transform.lastIndexOf("(") + 1, style.transform.lastIndexOf("px,"));

    let xCoordMod = xCoord < 0 ? xCoord : 0;

    let swipeOpacity = 0;

    if (Math.abs(xCoordMod) > 0 && Math.abs(yCoord) < 24) {
      swipeOpacity = Math.abs(xCoordMod) / 100;
    } else {
      xCoordMod = 0;
    }

    if (xCoordMod < -120 && !hide) {
      onChangeStatus();
    }

    const axisLockY = `translate(${xCoordMod}px, ${yCoordMod}px)`;
    return {
      ...style,
      transform: axisLockY,
      swipeOpacity,
    };
  }

  return style;
}
